/*
  NC: every video on the site autoplays (muted, inline, on repeat) on phones and desktop.
  - Plays when at least a quarter of it is on screen, pauses when scrolled away (saves data/battery).
  - Watches the page for videos added later (product recommendations, drawers, sliders, quick view).
  - If a phone blocks autoplay (e.g. iPhone Low Power Mode), it starts on the first touch or scroll.
  - Shoppers can still unmute with the theme's sound buttons; we only mute once, when the video first appears.
  - To exclude a video, add data-nc-no-autoplay to it.
*/
(function () {
  if (window.ncAutoplayVideos) return;
  window.ncAutoplayVideos = true;

  var seen = new WeakSet();
  var visible = new Set();

  function play(v) {
    if (!v.isConnected) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            visible.add(v);
            if (v.paused) play(v);
          } else {
            visible.delete(v);
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: 0.25 })
    : null;

  function prep(v) {
    if (seen.has(v) || v.hasAttribute('data-nc-no-autoplay')) return;
    seen.add(v);
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    v.setAttribute('loop', '');
    v.autoplay = true;
    v.setAttribute('autoplay', '');
    if (v.preload === 'none') v.preload = 'metadata';
    v.addEventListener('loadeddata', function () { if (!io || visible.has(v)) play(v); });
    if (io) { io.observe(v); } else { play(v); }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'VIDEO') prep(root);
    root.querySelectorAll('video').forEach(prep);
  }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // fallback for browsers that need a first interaction
  function kick() {
    (io ? visible : document.querySelectorAll('video')).forEach(function (v) { if (v.paused) play(v); });
  }
  ['touchstart', 'scroll', 'click', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, kick, { passive: true, once: true });
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
  NC: "Swipe for more →" under every swipeable row of length / shape / colour buttons, on mobile and desktop
  (homepage, collection pages, Build Your Bundle, Postcards x Australia). Only shows when the row is wider than
  the screen, and fades away once the shopper has reached the end. Clicking it scrolls the row along
  (handy on desktop with a mouse).
*/
(function () {
  if (window.ncSwipeHints) return;
  window.ncSwipeHints = true;

  var ROW = /(^|\s)(nc-cnav-[a-z0-9]+__row|nc-sets-[a-z0-9]+__chips|nc-bb__filters|nc-cs__filters)(\s|$)/;

  var css = document.createElement('style');
  css.textContent =
    '.nc-swipe-hint{display:none;margin:0;padding-top:2px;font-size:9.5px;line-height:1.2;letter-spacing:.16em;text-transform:uppercase;color:#8a837e;white-space:nowrap;cursor:pointer;user-select:none;transition:opacity .3s ease}' +
    '.nc-swipe-hint:hover{color:#151515}' +
    '.nc-swipe-hint span{display:inline-block;margin-left:4px;animation:nc-swipe-nudge 1.6s ease-in-out infinite}' +
    '.nc-swipe-hint.is-needed{display:block}' +
    '.nc-swipe-hint.is-done{opacity:0;pointer-events:none}' +
    '@keyframes nc-swipe-nudge{0%,100%{transform:translateX(0)}50%{transform:translateX(3px)}}' +
    '@media (prefers-reduced-motion: reduce){.nc-swipe-hint span{animation:none}}' +
    '@media (min-width:750px){.nc-swipe-hint{font-size:10px}}';
  document.head.appendChild(css);

  function setup(row) {
    if (row.__ncHint) return;
    var hint = document.createElement('p');
    hint.className = 'nc-swipe-hint';
    hint.innerHTML = 'Swipe for more<span aria-hidden="true">&rarr;</span>';
    hint.setAttribute('role', 'button');
    hint.setAttribute('tabindex', '0');
    row.insertAdjacentElement('afterend', hint);
    row.__ncHint = hint;
    var gap = parseFloat(getComputedStyle(row).marginBottom) || 0;

    function step() { row.scrollBy({ left: row.clientWidth * 0.7, behavior: 'smooth' }); }
    hint.addEventListener('click', step);
    hint.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); step(); } });

    function update() {
      var more = row.scrollWidth - row.clientWidth > 4;
      var cs = getComputedStyle(row);
      hint.style.paddingLeft = (parseFloat(cs.paddingLeft) || 0) + 'px';
      hint.classList.toggle('is-needed', more);
      if (more) {
        row.style.marginBottom = '4px';
        hint.style.marginBottom = gap + 'px';
      } else {
        row.style.marginBottom = '';
        hint.style.marginBottom = '';
      }
      hint.classList.toggle('is-done', more && row.scrollLeft + row.clientWidth >= row.scrollWidth - 8);
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function scan() {
    document.querySelectorAll('[class*="nc-cnav-"], [class*="nc-sets-"], .nc-bb__filters, .nc-cs__filters').forEach(function (el) {
      if (ROW.test(el.className)) setup(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
